//Style
import Styles from "./Appearance.module.scss";
import classnames from "classnames"

import lightOption from "../../../icons/light_option.png"
import darkOption from "../../../icons/dark_option.png"
import autoOption from "../../../icons/auto_option.png"
import InlineSetting from "./inline-setting/InlineSetting";
import ColorStrip from "../../color-strip/ColorStrip";
import DropDown from "../../drop-down/DropDown";
import Switch from "../../maincheckbox/MainCheckBox";
import RadioBoxGroup from "../../radio-group/RadioGroup";
import { useState } from "react";

const Appearance = () => {


    const [scrollbarType,setScrollbarType] = useState("auto");
    const [iconSize,setIconSize] = useState(0);

    const sidebarIconSize = [
        {
            id: 0,
            label: "Small"
        },
        {
            id: 1,
            label: "Medium"
        },
        {
            id: 2,
            label: "Large"
        }
    ]


    const scrollbarOptions=[
        {
            id:"auto",
            label:"Automatically based on mouse or Trackpad",
            value:"auto"
        },
        {
            id:"show",
            label:"When scrolling",
            value:"show"
        },
        {
            id:"scroll",
            label:"Always",
            value:"scroll"
        }
    ]

    const [isDarkTheme,setIsDarkTheme] =useState(document.body.classList.contains("dark"))

    const handleAddTheme = () => {
        document.body.classList.add("dark");
        setIsDarkTheme(true)
    }
    const handleRemoveTheme = () => {
        document.body.classList.remove("dark");
        setIsDarkTheme(false)
    }


    return (
        <div  style={{display:"flex", flexDirection:"column",gap:"8px"}}>
            <div className={Styles.container}>
                <InlineSetting leftContent="Appearance" rightContent={

                    <div className={classnames(Styles.flex,Styles.vertical)}>
                        <div className={Styles.flex}>
                            <div className={Styles.themeOpt}  onClick={handleRemoveTheme} >
                                <img className={!isDarkTheme ? Styles.activeTheme : ""} src={lightOption} />
                            </div>
                            <div className={Styles.themeOpt}  onClick={handleAddTheme} >
                                <img className={isDarkTheme ? Styles.activeTheme : ""} src={darkOption} />
                            </div>
                            <div className={Styles.themeOpt}  onClick={()=>{}} >
                                <img src={autoOption} />
                            </div>
                        </div>
                        <div className={Styles.flex}>

                            <div className={classnames(Styles.themeLabel,!isDarkTheme && Styles.activeThemeOpt)}  onClick={handleRemoveTheme}>Light</div>

                            <div className={classnames(Styles.themeLabel,isDarkTheme && Styles.activeThemeOpt)} onClick={handleAddTheme}>Dark</div>

                            <div className={Styles.themeLabel}>Auto</div>
                        </div>
                    </div>


                } />
                <InlineSetting leftContent="Color Accent" rightContent={<ColorStrip />} />
                <InlineSetting leftContent="Sidebar icon size" rightContent={

                    <DropDown  options={sidebarIconSize} selected={iconSize} handleClick={setIconSize} />
                } />
                <InlineSetting leftContent="Allow wallpaper tinting in window" rightContent={<Switch isChecked={false} disabled={true}/>} showDivider={false} />
            </div>
            <div className={Styles.container}>
                <RadioBoxGroup title={"Radio Box Group"} selectedOption={scrollbarType} handleChange={setScrollbarType} options={scrollbarOptions}  />
            </div>
        </div>
    )
}

export default Appearance
